export default () => {
	let combos = document.querySelectorAll(".fake-select");

	function createCombos() {
		combos = document.querySelectorAll(".fake-select");
		Array.prototype.forEach.call(combos, function (combo, index) {
			if(!combo.classList.contains('initialised'))
			{
				let parent = combo.parentNode;
				let select = parent.querySelectorAll("select")[0];
				let options = select.querySelectorAll("option");
				let list = combo.querySelectorAll("ul")[0];
				let label = combo.querySelectorAll("label")[0];
				let listItems = list.querySelectorAll("li");
				combo.classList.add('initialised');

				select.addEventListener("change", function (e) {
					if(window.innerWidth < 768) {
						let selectedValues = getSelectValues(select);
						if(selectedValues.length > 3) {
							e.preventDefault();
							return false;
						}
						Array.prototype.forEach.call(options, function (option, index) {
							const found = selectedValues.find(element => element == option.value);
							if(found !== undefined) {
								option.classList.add("selected");
								option.selected = "selected";
							} else {
								option.classList.remove("selected");
								option.selected = false;
							}
						});
					}
				});
				
				Array.prototype.forEach.call(listItems, function (item, index) {
					item.addEventListener("click", function () {
						let list = item.parentNode;
						let selectedListItems = list.querySelectorAll("li.selected");
						let optionString = "option[value='" + item.dataset.value + "']";
						let option = select.querySelectorAll(optionString)[0];

						if(!combo.classList.contains('fake-select--multiple')) {
							document.removeEventListener("click", closeAllCombos);
							list.classList.remove("open");
							parent.classList.remove("open");
							combo.classList.remove("open");
							item.classList.toggle("selected");
							if(option !== null) {
								option.classList.toggle("selected");
							}
							label.innerHTML = item.innerHTML;
						} else {
							if(!item.classList.contains("selected")) {
								if(selectedListItems.length < parseInt(combo.dataset.limit)) {
									item.classList.add("selected");
									if(option !== null) {
										option.classList.add("selected");
									}
								}
							} else {
								item.classList.remove("selected");
								if(option !== null) {
									option.classList.remove("selected");
								}
							}
							selectedListItems = list.querySelectorAll("li.selected");
							let labelValue = "";
							for (let j = 0; j < selectedListItems.length; j++) {
								labelValue += selectedListItems[j].innerHTML + ", ";
							}
							labelValue = labelValue.substring(0, labelValue.length - 2);
							label.innerHTML = labelValue;
						}
						select.value = item.dataset.value; 

						// Array.prototype.forEach.call(options, function (option, index) {
						// 	if(option.value == item.dataset.value && item.classList.contains("selected")) {
						// 		option.selected = 'selected';
						// 		option.classList.add('selected');
						// 	} else {
						// 		// option.selected = null;
						// 		// option.classList.remove('selected');
						// 	}
						// });

						let e = new Event("change");
						select.dispatchEvent(e);

						if(selectedListItems.length === 0 && combo.classList.contains('fake-select--multiple')) {
							let selectedFound = false;

							Array.prototype.forEach.call(options, function (option, index) {
								if(option.value == item.dataset.value && item.classList.contains("selected")) {
									selectedFound = true;
								}
							});

							if(!selectedFound) {
								label.innerHTML = options[0].innerHTML;
							}
						}
					});
		
					if(item.classList.contains("selected")) {
						label.innerHTML = item.innerHTML;
					}

					if(combo.classList.contains('fake-select--multiple')) {
						let selectedListItems = list.querySelectorAll("li.selected");
						let labelValue = "";
						for (let j = 0; j < selectedListItems.length; j++) {
							labelValue += selectedListItems[j].innerHTML + ", ";
						}
						labelValue = labelValue.substring(0, labelValue.length - 2);
						if(labelValue !== '') {
							label.innerHTML = labelValue;
						}
					}
				});
		
				label.addEventListener("click", function () {
					document.removeEventListener("click", closeAllCombos);
					if(list.classList.contains("open")) {
						list.classList.remove("open");
						parent.classList.remove("open");
						combo.classList.remove("open");
					} else {
						closeAllCombos();
						list.classList.add("open");
						parent.classList.add("open");
						combo.classList.add("open");
						setTimeout(() => {
							document.addEventListener("click", closeAllCombos);
						}, 500);
					}
				});
			}
		});
	}

	function getSelectValues(select) {
		var result = [];
		var options = select && select.options;
		var opt;
	  
		for (var i=0, iLen=options.length; i<iLen; i++) {
		  opt = options[i];
	  
		  if (opt.selected) {
			result.push(opt.value || opt.text);
		  }
		}
		return result;
	}

	function closeAllCombos() {
		document.removeEventListener("click", closeAllCombos);
		Array.prototype.forEach.call(combos, function (combo, index) {
			let list = combo.querySelectorAll("ul")[0];
			let parent = combo.parentNode;
			list.classList.remove("open");
			parent.classList.remove("open");
			combo.classList.remove("open");
		});
	}

	document.addEventListener("create-combos", createCombos);

	createCombos();
};
